// ----------------------------------------------------------------------

const account = {
  displayName: 'User',
  email: 'demo@test.com',
  photoURL: '/assets/images/avatars/avatar_default.jpg',
};

export default account;
